import { render, staticRenderFns } from "./EmptyWord.vue?vue&type=template&id=b7d85d9a&scoped=true&"
import script from "./EmptyWord.vue?vue&type=script&lang=js&"
export * from "./EmptyWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d85d9a",
  null
  
)

export default component.exports